import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';
import { App as CommerceApp, ConfigContextProvider, Portal } from '../../aem-core-components';
import CheckoutDotcom from '../../components/checkoutv2/Checkout';
import LocationDistanceWarningBanner from '../../aem-core-components/components/Banner/LocationDistanceWarningBanner/LocationDistanceWarningBanner';
import GetGeoLocation from '../global/atoms/GetGeoLocation/GetGeoLocation';
import { initSentry } from '../global/utils/logger';
import partialConfig from '../App/config';
import loadLocaleData, { locale, messages } from '../App/i18n';
import UtilityBanner from '../global/modules/utilityBanner/UtilityBanner';
import PunchoutBanner from '../global/modules/punchoutBanner/PunchoutBanner';
import BackToCart from '../checkoutv2/BackToCart';

const App = props => {
    const {
        storeView,
        graphqlEndpoint,
        graphqlMethod = 'POST',
        headers = '{}'
    } = JSON.parse(
        document.querySelector('meta[name="store-config"]')?.content ||
        document.querySelector('div[name="store-config"]')?.getAttribute('content') ||
        '{}'
    );
    const { mountingPoints, pagePaths } = partialConfig;
    const config = {
        ...partialConfig,
        storeView,
        graphqlEndpoint,
        // Can be GET or POST. When selecting GET, this applies to cache-able GraphQL query requests only. Mutations
        // will always be executed as POST requests.
        graphqlMethod,
        headers
    };
    return (
        <IntlProvider locale={locale} messages={messages}>
            <ConfigContextProvider config={config}>
                <CommerceApp>
                    <Portal selector={mountingPoints.punchoutBanner}>
                        <PunchoutBanner />
                    </Portal>
                    <Portal selector={mountingPoints.checkoutPage}>
                        <CheckoutDotcom />
                    </Portal>
                    <Portal selector={mountingPoints.getUtilityBanner}>
                        <UtilityBanner />
                    </Portal>
                    <Portal selector={mountingPoints.getGeoLoation}>
                        <GetGeoLocation />
                    </Portal>
                    <Portal selector={mountingPoints.locDistanceWarningBanner}>
                        <LocationDistanceWarningBanner />
                    </Portal>
                    <Portal selector={mountingPoints.backToCartCta}>
                        <BackToCart />
                    </Portal>
                </CommerceApp>
            </ConfigContextProvider>
        </IntlProvider>
    );
};

const renderDOM = async () => {
    const { locale, messages } = await loadLocaleData();
    const root = document.createElement('div');
    document.body.appendChild(root);
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (!isDevelopment) {
        await initSentry();
    }
    const rootContainer = createRoot(root);
    rootContainer.render(
        <Router>
            <App locale={locale} messages={messages} />
        </Router>
    );
};

document?.addEventListener('readystatechange', () => {
    if (document?.readyState === 'complete') {
        renderDOM();
    }
});

export default App;
